import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { useAppAuth } from "@/context/AppAuthContext";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAppAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // clear the fragment so the token isn't left in the URL / history
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/vhod", { replace: true });
      return;
    }

    const dest = sessionStorage.getItem("pd_login_from") || "/profil";
    sessionStorage.removeItem("pd_login_from");

    loginWithGoogleSession(sessionId)
      .then(() => {
        toast.success("Влязохте с Google.");
        navigate(dest, { replace: true });
      })
      .catch((err) => {
        setError(formatApiErrorDetail(err.response?.data?.detail) || "Неуспешно влизане с Google.");
        setTimeout(() => navigate("/vhod", { replace: true }), 2200);
      });
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-50 px-4 text-center" data-testid="auth-callback">
      {error ? (
        <p className="text-sm font-medium text-red-600">{error}</p>
      ) : (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-sm text-slate-500">Влизане с Google…</p>
        </>
      )}
    </div>
  );
}
